<ion-header>
  <ion-toolbar>
    <ion-title mode="ios">Enregistrement Vidéo</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="cancelRecording()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-row class="ion-justify-content-center ion-padding-vertical">
      <div class="c-record-time">
        {{ timeRecording | timeFormatPipe:'ms' }} - {{ timeLimit | timeFormatPipe:'s' }}
      </div>
    </ion-row>
    <ion-row class="ion-justify-content-center ion-padding-vertical">
      <button class="c-button-reccord c-button-reccord-start"*ngIf="!recording" (click)="startRecording()"><div class="c-inner"></div></button>
      <button class="c-button-reccord c-button-reccord-stop" *ngIf="recording" (click)="stopRecording()"><div class="c-inner"></div></button>
    </ion-row>
  </ion-toolbar>
</ion-footer>